export default "__VITE_ASSET__CMCulbKP__"